// @flow
import { prefixRoutes } from 'metaup/routing/routingUtils';
import { offlineTokensListPageRoutes } from './OfflineTokensListPage';
import { offlineTokenCreatePageRoutes } from './OfflineTokenCreatePage';

export function offlineTokensRoutes() {
  return prefixRoutes('/', [
    ...offlineTokensListPageRoutes(),
    ...offlineTokenCreatePageRoutes(),
  ]);
}
